<template>
  <v-btn
    class="cus-Btn"
    @click="doFunction"
    plain
    :class="[Color(colorType), userTheme ? `${Color(colorType)}-${userTheme}` : '']"
    small
    :height="height"
    :disabled="disabled"
    :width="width">
    <slot></slot>
  </v-btn>
</template>

<script>
import { mapState } from 'vuex';
/**
 * 這是按紐，可以把icon跟文字寫在父層
 * */
export default {
  name: 'DefaultButton',
  props: {
    colorType: {
      type: [String],
      default() {
        return 'primary';
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: [Number, String],
      default() {
        return 32;
      },
    },
    width: {
      type: [Number, String],
    },
  },
  methods: {
    doFunction() {
      this.$emit('doFunction');
    },
  },
  computed: {
    ...mapState('userInfo', ['userInfo']),
    userTheme() {
      let theme = '';
      if (this.userInfo.userStyle) {
        theme = this.userInfo.userStyle;
      }
      return theme;
    },
    Color() {
      return (value) => {
        let className = '';
        switch (value) {
        case 'primary':
          className = 'cus-Btn__primaryOrange__2';
          break;
        case 'secondary':
          className = 'cus-Btn__secondary';
          break;
        case 'tertiary':
          className = 'cus-Btn__tertiary';
          break;
        case 'quaternary':
          className = 'cus-Btn__quaternary';
          break;
        case 'quinary':
          className = 'cus-Btn__quinary';
          break;
        case 'senary':
          className = 'cus-Btn__senary';
          break;
        case 'septenary':
          className = 'cus-Btn__septenary';
          break;
        case 'update':
          className = 'cus-Btn__primaryGreen__2';
          break;
        case 'delete':
          className = 'cus-Btn__primaryRed__2';
          break;
        case 'read':
          className = 'cus-Btn__primaryBlue__2';
          break;
        case 'cancel':
          className = 'cus-Btn__primaryGray__2';
          break;
        case 'primary--orange':
          className = 'cus-Btn__primaryOrange';
          break;
        case 'primary--green':
          className = 'cus-Btn__primaryGreen';
          break;
        case 'primary--blue':
          className = 'cus-Btn__primaryBlue';
          break;
        case 'primary--red':
          className = 'cus-Btn__primaryRed';
          break;
        case 'primary--gray':
          className = 'cus-Btn__primaryGray';
          break;
        case 'primary--orange--1':
          className = 'cus-Btn__primaryOrange__1';
          break;
        case 'primary--green--1':
          className = 'cus-Btn__primaryGreen__1';
          break;
        case 'primary--blue--1':
          className = 'cus-Btn__primaryBlue__1';
          break;
        case 'primary--red--1':
          className = 'cus-Btn__primaryRed__1';
          break;
        case 'primary--gray--1':
          className = 'cus-Btn__primaryGray__1';
          break;
        case 'primary--orange--2':
          className = 'cus-Btn__primaryOrange__2';
          break;
        case 'primary--green--2':
          className = 'cus-Btn__primaryGreen__2';
          break;
        case 'primary--blue--2':
          className = 'cus-Btn__primaryBlue__2';
          break;
        case 'primary--red--2':
          className = 'cus-Btn__primaryRed__2';
          break;
        case 'primary--gray--2':
          className = 'cus-Btn__primaryGray__2';
          break;
        default:
          className = 'cus-Btn__primary';
          break;
        }
        return className;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep i {
  font-size: 20px;
}

::v-deep i + span {
  display: none;
  @include pad-width() {
    display: unset;
  }
}

::v-deep .btn-group__text {
  display: flex;
  flex-direction: column;

  span {
    text-transform: initial;
    word-break: break-all;
  }
}

::v-deep .w {

  &-100 {
    width: 100px;
    white-space: break-spaces;
  }
  &-200 {
    width: 200px;
    white-space: break-spaces;
  }
}

.v-btn::before {
  background-color: transparent;
}

::v-deep .v-btn__content {
  opacity: 1 !important;
}
</style>
